/**
 * @desc 列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.LogisticsAttrModel>>;
export function request(
  body: defs.basics.LogisticsAttrRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/logisticsAttr/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
